import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-mouse',
    templateUrl: './mouse.component.html',
    styleUrls: ['./mouse.component.scss'],
    standalone: false
})
export class MouseComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
